import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../redux/actions/authActions/authAction";
import NoDataFound from "../Common/NoDataFound";
import Loader from "../Common/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Alert from "../Common/Alert";
import {
  convertFirstLetterOfFullNameToCapital,
  convertFirstLetterToCapital,
  customName,
  getColorFromId,
} from "../../helpers/commonHelpers";
import {
  getactionActivitiesDetails,
  processReassign,
} from "../../redux/actions/actionAction/ActionAction";
import ReassignModal from "./ReassignModal";
import OtherModal from "./OtherModal";

const ViewActionActivities = React.memo((props) => {
 
  const mainActionData = useSelector((state) => state.action);
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activityDetails, setActivityDetails] = useState(null);
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [requestedId, setRequestedId] = useState(null);
  const employeeData = useSelector((state) => state.user);
  const actionData = useSelector((state) => state.action);
  const [actionId, setActionId] = useState(null);
  const [actionDatas, setActionDatas] = useState(null);
  const [activityId, setActivityId] = useState(null);
  useEffect(() => {
    if (accessToken) {
      dispatch(getactionActivitiesDetails(props.actionId, accessToken));
    }

    return () => {
      // Anything in here is fired on component unmount.
    };
  }, [actionData?.actionActivitiesDetails?.length, actionData?.isSuccess]);

  const handleModal = (activity) => {
    setActivityDetails(activity);
    setIsModalOpen(true);
  };
  const handleReassignModal = (action, activity, actId, requestedId) => {
    setActivityId(actId);
    setActivityDetails(activity);
    setActionId(action._id);
    setActionDatas(action);
    setIsReassignModalOpen(true);
    setRequestedId(requestedId);
  };

  const handleReassign = (data, status) => {
    // alert(29)
    const assignedUsers = data.assignedUsers;
    if (status) {
      dispatch(
        processReassign(
          actionId,
          {
            organizationId: userData.organizationId,
            assignedUsers: assignedUsers,
            reAssignReason: data.reason,
            dueDate: data.date ? data.date : undefined,
            priority: data.priority,
            lastActionActivityId: data?.lastActionActivityId
              ? data?.lastActionActivityId
              : undefined,
            isAcceptedClick: true,
            requestedId: requestedId,
          },
          accessToken
        )
      );
     // alert("View Action Activity Page--if")
       dispatch(getactionActivitiesDetails(actionId,accessToken));
    } else {
      dispatch(
        processReassign(
          actionId,
          {
            organizationId: userData.organizationId,
            assignedUsers: assignedUsers,
            reAssignReason: data.reason,
            dueDate: data.date ? data.date : undefined,
            priority: data.priority,
            lastActionActivityId: data?.lastActionActivityId
              ? data?.lastActionActivityId
              : undefined,
            isAcceptedClick: true,
            requestedId: requestedId,
          },
          accessToken
        )
         
      );
      // alert(actionId)
       //  alert("View Action Activity Page --- else",actionId)
      dispatch(getactionActivitiesDetails(actionId,accessToken));
    }
    setActionId(null);
  };

  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  return (
    <form className="mt-2 details-form details-form-right">
      <div className="form-group agenda">
        <div className="left-detailbox">
          <h4 className="Detailsheading">Action Activities</h4>

          <div className="timeline timeline-border-dashed mt-3 action-activity-timeline">
            {actionData?.actionActivitiesDetails?.length > 0 &&
            !actionData.loading ? (
              <>
                {actionData?.actionActivitiesDetails.map((activity) => {
                  return (
                    <>
                      {activity?.reAssignedUserDetails?.length > 0 &&
                      activity.activityTitle !== "ACTION REOPENED" ? (
                        <>
                          <div className="timeline-item activity-timeline">
                            <div className="timeline-line"></div>
                            <OverlayTrigger
                              placement="top"
                              overlay={tooltip(
                                activity?.reAssignedUserDetails[0]
                              )}
                              trigger={["hover", "focus"]}
                            >
                              <div className="timeline-icon me-3">
                               
                                <div
                                  className="attendee-list pk ok attendee-list-circle"
                                  style={{
                                    backgroundColor: activity
                                      ?.reAssignedUserDetails[0]?.profilePicture
                                      ? undefined
                                      : getColorFromId(
                                          activity?.reAssignedUserDetails[0]
                                            ?._id
                                        ),
                                  }}
                                >
                                  {activity?.reAssignedUserDetails[0]
                                    ?.profilePicture ? (
                                    <img
                                      src={`${process.env.REACT_APP_API_URL}${activity?.reAssignedUserDetails[0]?.profilePicture}`}
                                      alt=""
                                      className="attendee-profile-picture icon-image attendee-list-circle-img"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = "none";
                                        e.target.parentElement.style.backgroundColor =
                                          getColorFromId(
                                            activity?.reAssignedUserDetails[0]
                                              ?._id
                                          );
                                        e.target.parentElement.innerText =
                                          customName(
                                            activity?.reAssignedUserDetails[0]
                                              ?.name
                                          );
                                      }}
                                    />
                                  ) : (
                                    customName(
                                      activity?.reAssignedUserDetails[0]?.name
                                    )
                                  )}
                                </div>
                              </div>
                            </OverlayTrigger>
                            <div className="timeline-content mb-8 mt-n2">
                              <div className="">
                                <div className="heading mb-1">
                                  <p>
                                    {" "}
                                    {convertFirstLetterToCapital(
                                      activity?.activityTitle
                                    )}{" "}
                                    to{" "}
                                    {convertFirstLetterOfFullNameToCapital(
                                      activity?.reAssignedUserDetails[0]?.name
                                    )}
                                  </p>
                                </div>
                                <div className="d-flex align-items-center fs-6">
                                  <div className="text-muted me-2 fs-7">
                                    {activity.date}
                                  </div>
                                </div>
                                <div className="">
                                  <button
                                    className="reset"
                                    type="button"
                                    onClick={() => {
                                      handleModal(activity);
                                    }}
                                  >
                                    <p>View Details</p>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="timeline-item activity-timeline">
                            <div className="timeline-line"></div>
                            <div className="timeline-icon me-4">
                              
                              <div
                                className="attendee-list pk attendee-list-circle"
                                style={{
                                  backgroundColor: activity?.employeeDetails
                                    ?.profilePicture
                                    ? undefined
                                    : getColorFromId(
                                        activity?.employeeDetails?._id
                                      ),
                                }}
                              >
                                {activity?.employeeDetails?.profilePicture ? (
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}${activity?.employeeDetails?.profilePicture}`}
                                    alt=""
                                    className="attendee-profile-picture icon-image attendee-list-circle-img"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
                                      e.target.parentElement.style.backgroundColor =
                                        getColorFromId(
                                          activity?.employeeDetails?._id
                                        );
                                      e.target.parentElement.innerText =
                                        customName(
                                          activity?.employeeDetails?.name
                                        );
                                    }}
                                  />
                                ) : (
                                  customName(activity?.employeeDetails?.name)
                                )}
                              </div>
                            </div>
                            <div className="timeline-content mb-8 mt-n2">
                              <div className="">
                                <div className="heading mb-1">
                                  <p>
                                    {" "}
                                    {convertFirstLetterToCapital(
                                      activity.activityTitle
                                    )}{" "}
                                    by{" "}
                                    {convertFirstLetterOfFullNameToCapital(
                                      activity.employeeDetails?.name
                                    )}
                                  </p>
                                </div>
                                <div className="d-flex align-items-center fs-6">
                                  <div className="text-muted me-2 fs-7">
                                    {activity.date}
                                  </div>
                                </div>
                                <div className="">
                                  <button
                                    className="reset"
                                    type="button"
                                    onClick={() => {
                                      handleModal(activity);
                                    }}
                                  >
                                    <p>View Details</p>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="timeline-item activity-timeline">
                            <div className="timeline-line"></div>
                            <div className="timeline-icon me-3">
                              <div
                                className="attendee-list pk attendee-list-circle"
                                style={{
                                  backgroundColor: activity?.employeeDetails
                                    ?.profilePicture
                                    ? undefined
                                    : getColorFromId(
                                        activity?.employeeDetails?._id
                                      ),
                                }}
                              >
                                {activity?.employeeDetails?.profilePicture ? (
                                  <img
                                    className="attendee-list-circle-img icon-image"
                                    src={`${process.env.REACT_APP_API_URL}${activity?.employeeDetails?.profilePicture}`}
                                    alt=""
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";

                                      e.target.parentElement.style.backgroundColor =
                                        getColorFromId(
                                          activity?.employeeDetails?._id
                                        );
                                      e.target.parentElement.innerText =
                                        customName(
                                          activity?.employeeDetails?.name
                                        );
                                    }}
                                  />
                                ) : (
                                  customName(activity?.employeeDetails?.name)
                                )}
                              </div>
                            </div>
                            <div className="timeline-content mb-8 mt-n1">
                              <div className="">
                                <div className="heading mb-1">
                                  <p>
                                    {" "}
                                    {convertFirstLetterToCapital(
                                      activity.activityTitle
                                    )}{" "}
                                    by{" "}
                                    {convertFirstLetterOfFullNameToCapital(
                                      activity.employeeDetails?.name
                                    )}
                                  </p>
                                </div>
                                <div className="d-flex align-items-center fs-6">
                                  <div className="text-muted me-2 fs-7">
                                    {activity.date}
                                  </div>
                                </div>

                                {activity.activityDetails ? (
                                  <div className="mt-2">
                                    {activity.activityTitle !==
                                      "ACTION REOPENED" &&
                                    actionData?.singleActionDetails
                                      ?.isRequested === true &&
                                    activity.activityTitle !==
                                      "ACTION COMPLETED" &&
                                    (employeeData.userData?.isAdmin ||
                                      employeeData?.userData?._id?.toString() ===
                                        props?.action?.meetingDetail?.createdById?.toString()) &&
                                    actionData?.singleActionDetails
                                      ?.isComplete === false &&
                                    actionData?.singleActionDetails
                                      ?.isCancelled === false &&
                                  
                                    activity?.isRead === false ? (
                                      <button
                                        className="reset"
                                        type="button"
                                        onClick={() => {
                                          handleReassignModal(
                                            props.action,
                                            activity.activityDetails,
                                            activity?._id,
                                            activity.employeeDetails?._id
                                          );
                                        }}
                                      >
                                        <p>View & Take Action</p>
                                      </button>
                                    ) : (
                                      <button
                                        className="reset"
                                        type="button"
                                        onClick={() => {
                                          handleModal(activity);
                                        }}
                                      >
                                        <p>View Details</p>
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <p className="opacity0">View Details</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  );
                })}
              </>
            ) : actionData?.actionActivitiesDetails?.length === 0 &&
              !actionData.loading ? (
              <div className="no-data-img mt-3">
                <Alert
                  status={"info"}
                  message={"No data available."}
                  timeoutSeconds={0}
                />
                <NoDataFound />
              </div>
            ) : (
              <div className="meeting-page text-center">
                <Loader />
              </div>
            )}
          </div>
        </div>

        <ReassignModal
          setIsReassignModalOpen={setIsReassignModalOpen}
          isModalOpen={isReassignModalOpen}
          handleSubmit={handleReassign}
          activity={activityDetails}
          actionId={props.actionId}
          actionData={actionDatas}
          meetingDate={mainActionData?.singleActionDetails?.meetingDetail?.date}
          activityId={activityId}
          requestedId={requestedId}
          isFromViewAction={true}
        />

        <OtherModal
          setIsModalOpen={setIsModalOpen}
          IsModalOpen={isModalOpen}
          activity={activityDetails}
        />
      </div>
    </form>
  );
});

export default ViewActionActivities;
